import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { ReactComponent as UnpaidIcon } from '../../../../../../assets/icons/svg/stamp-icons/ic-stamp-unpaid.svg';
import { useStore } from '../../../../../../store';
import { HUB_MODALS } from '../../InvoiceHubModals';
import { markAsUnPaidAPIAction } from '../../../api/markAsUnpaidAPIAction';
import { InvoiceMarkAsPaidSuccess } from '../../Toasts/InvoiceMarkAsPaidSuccess';
import { isInvoiceStatusSent, isInvoiceStatusUnsent } from '../../../utils';

interface IProps {
  onClose: () => void;
  externalId: string;
  invoiceStatus: string;
}

export const MarkAsUnpaid = ({ onClose, externalId, invoiceStatus }: IProps) => {
  const setActiveModal = useStore((state) => state.setActiveModal);
  const { customerId } = useStore((state) => state.user);
  const setError = useStore((state) => state.setError);
  const removeInvoiceFromList = useStore((state) => state.removeInvoiceFromList);
  const { t } = useTranslation();

  const handleSubmit = async () => {
    onClose();
    setActiveModal(HUB_MODALS.SPINNER);
    try {
      const response = await markAsUnPaidAPIAction(customerId, externalId);
      setActiveModal(HUB_MODALS.NONE);
      if (isInvoiceStatusSent(response?.invoiceStatus) || isInvoiceStatusUnsent(response?.invoiceStatus)) {
        toast(<InvoiceMarkAsPaidSuccess />, {
          position: toast.POSITION.TOP_CENTER,
          bodyClassName: 'p-0 text-bw00',
          className: 'w-[370px] h-[60px] bg-bw08 p-0',
        });
        removeInvoiceFromList(invoiceStatus, externalId);
      }
    } catch (error: any) {
      setError(error);
      setActiveModal(HUB_MODALS.ERROR);
    }
  };

  return (
    <div
      data-testid='invoiceHub-markAsPaid-main'
      className='flex flex-nowrap flex-col h-[340px] w-[343px] bg-bw00 rounded-lg border-[1px] border-bw03 px-[24px] pt-[34px] pb-[24px] box-border'
    >
      <div className='flex justify-center flex-nowrap w-full mb-[25px]'>
        <UnpaidIcon />
      </div>
      <div className='font-metricRMedium text-lg text-bw08 leading-6 mb-[8px] text-center'>
        {t('INVOICE_HUB_MODALS.MARK_AS_UNPAID.TITLE')}
      </div>
      <div className='font-metricR text-md text-bw07 leading-6 mb-[22px] text-center'>
        {t('INVOICE_HUB_MODALS.MARK_AS_UNPAID.SUBTITLE')}
      </div>
      <div className='flex justify-end'>
        <LiliButton
          testId='invoiceHub-markAsPaid-buttonCancel'
          id='invoiceHub-markAsPaid-buttonCancel'
          onClick={onClose}
          type={LiliButtonType.SECONDARY}
          title={t('INVOICE_HUB_MODALS.MARK_AS_UNPAID.BUTTON_CANCEL')}
          className='h-[54px] w-[140px]'
        />
        <LiliButton
          testId='invoiceHub-markAsPaid-buttonUnpaid'
          id='invoiceHub-markAsPaid-buttonUnpaid'
          onClick={handleSubmit}
          title={t('INVOICE_HUB_MODALS.MARK_AS_UNPAID.BUTTON_UNPAID')}
          className='h-[54px] w-[140px] ml-[12px]'
        />
      </div>
    </div>
  );
};
